
import { createContext, useState } from "react";

export const JobContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [jobs, setJobs] = useState([]);

    // Make the context object:
    const jobContext = {
        jobs,
        setJobs,
    };

    // pass the value in provider and return
    return <JobContext.Provider value={jobContext}>{children}</JobContext.Provider>;
};

export const { Consumer } = JobContext;
